import { Link as RemixLink } from "@remix-run/react";

type SmartLinkProps = {
  to: string;
  children: React.ReactNode;
  className?: string;
  target?: string;
  rel?: string;
  style?: React.CSSProperties;
};

export default function Link({
  to,
  children,
  className,
  target,
  rel,
  style,
}: SmartLinkProps) {
  const isExternal = /^https?:|^mailto:|^tel:/i.test(to);

  if (isExternal) {
    return (
      <a
        href={to}
        className={className}
        target={target || "_blank"}
        rel={rel || "noopener noreferrer"}
        style={style}
      >
        {children}
      </a>
    );
  }

  return (
    <RemixLink to={to} className={className} style={style}>
      {children}
    </RemixLink>
  );
}
